// NGRX
import {Store, select} from '@ngrx/store';
// CRUD
import {BaseDataSource, QueryResultsModel} from '../../_base/crud';
// State
import {AppState} from '../../reducers';
// Selectors
import {
    selectRentReviewCommentQueryResult,
    selectRentReviewCommentsPageLoading,
    selectRentReviewCommentsShowInitWaitingMessage
} from '../_selectors/rent-review-comment.selectors';

export class RentReviewCommentsDataSource extends BaseDataSource {
    constructor(private store: Store<AppState>) {
        super();

        this.loading$ = this.store.pipe(
            select(selectRentReviewCommentsPageLoading)
        );

        this.isPreloadTextViewed$ = this.store.pipe(
            select(selectRentReviewCommentsShowInitWaitingMessage)
        );

        this.store.pipe(
            select(selectRentReviewCommentQueryResult)
        ).subscribe((response: QueryResultsModel) => {
            this.paginatorTotalSubject.next(response.totalCount);
            this.entitySubject.next(response.items);
        });

    }
}
